// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
import { z } from "zod";

/** Search params for the tickets page: the open ticket. */
export const portalTicketsSearch = z.object({ ticket: z.string().optional() });
export type TicketsSearch = z.infer<typeof portalTicketsSearch>;
